module.exports = "/static/assets/86c1e3c64f35c3bef0d88ff949b23a15.svg";